<template>
  <div class="row">
    <!-- Course Grid -->
    <div class="col-xxl-4 col-md-6 d-flex" 
      v-for="enrollment in enrollments" :key="enrollment.id">
      <div class="course-box flex-fill">
        <div class="product">
          <div class="product-img">
            <router-link :to="'/course/' + enrollment.id">
              <img v-if="!enrollment?.course?.coverImage"
                class="img-fluid"
                alt="Img"
                src="@/assets/img/course/course-02.jpg"
              />
              <img v-else
                class="img-fluid"
                alt="Img"
                :src="enrollment?.course?.coverImage"
              />
            </router-link>
            <div class="price">
              <h3> <span></span></h3>
            </div>
          </div>
          <div class="product-content">
            <div class="course-group d-flex">
              <div class="course-group-img d-flex">
                <router-link :to="'/course/' + enrollment.id"
                  ><img v-if="!enrollment?.course?.instructor.profileImageUrl"
                    src="@/assets/img/user/user2.jpg"
                    alt="Img"
                    class="img-fluid"
                />
                <img v-else
                    :src="enrollment?.course?.instructor.profileImageUrl"
                    alt="Img"
                    class="img-fluid"
                />
              </router-link>
                <div class="course-name">
                  <h4>
                    <router-link :to="'/course/' + enrollment.id"
                      >{{enrollment?.course?.instructor?.fullName}}</router-link
                    >
                  </h4>
                  <p>Instructor</p>
                </div>
              </div>
              <div
                class="course-share d-flex align-items-center justify-content-center"
              >
                <!-- <a href="#"><i class="fa-regular fa-heart"></i></a> -->
              </div>
            </div>
            <h3 class="title instructor-text">
              <router-link :to="'/course/' + enrollment.id"
                >{{enrollment?.course?.title}}</router-link
              >
            </h3>
            <div class="course-info d-flex align-items-center">
              <div class="rating-img d-flex align-items-center">
                <img src="@/assets/img/icon/icon-01.svg" alt="Img" />
                <p>{{enrollment?.course?.lessonsCount}}+ Aulas</p>
              </div>
              <!-- <div class="course-view d-flex align-items-center">
                <img src="@/assets/img/icon/icon-02.svg" alt="Img" />
                <p>70hr 30min</p>
              </div> -->
            </div>
            <div class="rating mb-0">
              <i class="fas fa-star filled me-1"></i>
              <i class="fas fa-star filled me-1"></i>
              <i class="fas fa-star filled me-1"></i>
              <i class="fas fa-star filled me-1"></i>
              <i class="fas fa-star filled me-1"></i>
              <span class="d-inline-block average-rating"
                ><span>5.0</span> (20)</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Course Grid -->
    <!-- /Course Grid -->
  </div>
</template>
<script setup>
import { toCurrency } from '@/utils';
defineProps({
  enrollments: {
    type: Array,
    required: true,
  },
});
</script>
